<dx-form
  #editDeviceForm
  (onFieldDataChanged)="checkEditDeviceValidation()"
  (onOptionChanged)="checkEditDeviceValidation()"
  [(formData)]="editedDeviceFull"
  [labelLocation]="'top'"
  [labelMode]="'floating'">
  <div *dxTemplate="let tab of 'titleWithValidation'" class="flexRow">
    <span>{{ tab.title }}</span>
    <div *ngIf="!checkTabValidity(tab, editDeviceForm)" class="invalidBadge">!</div>
    <app-row-state-badge *ngIf="tab.title === ('REGISTRY.DEVICE.TABS.METRICS' | translate)"
                         [trackers]="rowStateTrackers"></app-row-state-badge>
  </div>
  <dxi-item itemType="tabbed">
    <dxo-tab-panel-options
      [deferRendering]="false"
      [elementAttr]="{class: 'tabPanelAbsolute'}"></dxo-tab-panel-options>
    <dxi-tab
      [tabTemplate]="'titleWithValidation'"
      title="{{'REGISTRY.DEVICE.TABS.INFORMATION' | translate}}">
      <dxi-item
        [editorOptions]="deviceEditTextOptions" dataField="name">
        <dxo-label text="{{'REGISTRY.DEVICE.NAME' | translate}}"></dxo-label>
        <dxi-validation-rule [max]="gmService.STR_DIM_MID"
                             [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MID)"
                             type="stringLength"></dxi-validation-rule>
        <dxi-validation-rule message="{{'REGISTRY.DEVICE.VALIDATION.NAME_CHARACTERS' | translate}}" type="custom"
                             [validationCallback]="validateDeviceName"></dxi-validation-rule>
        <dxi-validation-rule message="{{'REGISTRY.DEVICE.VALIDATION.NAME' | translate}}"
                             type="required"></dxi-validation-rule>
      </dxi-item>
      <dxi-item
        [editorOptions]="{
          dataSource: this.filteredDeviceTypes,
          displayExpr: 'label',
          valueExpr: 'id',
          disabled: !this.isEditMode,
          searchEnabled: true
        }" dataField="defaultType"
        editorType="dxSelectBox">
        <dxo-label text="{{'REGISTRY.DEVICE.REFERENCE_TYPE' | translate}}"></dxo-label>
        <dxi-validation-rule message="{{'REGISTRY.DEVICE.VALIDATION.TYPE' | translate}}"
                             type="required"></dxi-validation-rule>
      </dxi-item>

      <dxi-item
        [editorOptions]="{
          dataSource: acquisitionCronFrequencyValues,
          displayExpr: getAcquisitionCronLabel,
          disabled: !this.isEditMode
        }" dataField="acquisitionCron"
        editorType="dxSelectBox">
        <dxo-label text="{{'REGISTRY.DEVICE.ACQUISITION_FREQUENCY' | translate}}"></dxo-label>
        <dxi-validation-rule message="{{'REGISTRY.DEVICE.VALIDATION.ACQUISITION_FREQUENCY' | translate}}"
                             type="required"></dxi-validation-rule>
      </dxi-item>
    </dxi-tab>
    <dxi-tab [tabTemplate]="'titleWithValidation'" title="Configurazione">
      <ng-container *ngIf="editedDeviceFull?.protocolType == 'MODBUS_RTU'">

        <!---------------------------->
        <!--      MODBUS_RTU        -->
        <!---------------------------->


        <dxi-item [editorOptions]="deviceEditNumberOptions" dataField="transportConfiguration.deviceAddr"
                  editorType="dxNumberBox">
          <dxo-label text="{{'REGISTRY.DEVICE.DEVICE_ADDR' | translate}}"></dxo-label>
          <dxi-validation-rule message="{{'REGISTRY.DEVICE.VALIDATION.DEVICE_ADDR' | translate}}"
                               type="required"></dxi-validation-rule>
        </dxi-item>

        <dxi-item [editorOptions]="{
                                            dataSource: this.selectedGateway?.type?.additionalInfo?.rtuPorts,
                                            disabled: !this.isEditMode
                                          }" dataField="transportConfiguration.portName" editorType="dxSelectBox">
          <dxo-label text="{{'REGISTRY.DEVICE.PORT_NAME' | translate}}"></dxo-label>
          <dxi-validation-rule message="{{'REGISTRY.DEVICE.VALIDATION.PORT_NAME' | translate}}"
                               type="required"></dxi-validation-rule>
        </dxi-item>

        <dxi-item [editorOptions]="deviceEditNumberOptions" dataField="transportConfiguration.timeout"
                  editorType="dxNumberBox">
          <dxo-label text="{{'REGISTRY.DEVICE.TIMEOUT' | translate}}"></dxo-label>
          <dxi-validation-rule message="{{'REGISTRY.DEVICE.VALIDATION.TIMEOUT' | translate}}"
                               type="required"></dxi-validation-rule>
        </dxi-item>

        <dxi-item [editorOptions]="deviceEditNumberOptions" dataField="transportConfiguration.baudRate"
                  editorType="dxNumberBox">
          <dxo-label text="{{'REGISTRY.DEVICE.BAUD_RATE' | translate}}"></dxo-label>
          <dxi-validation-rule message="{{'REGISTRY.DEVICE.VALIDATION.BAUD_RATE' | translate}}"
                               type="required"></dxi-validation-rule>
        </dxi-item>

        <dxi-item [editorOptions]="deviceEditTextOptions" dataField="transportConfiguration.combinedField">
          <dxo-label text="{{'REGISTRY.DEVICE.COMBINED_FIELD' | translate}}"></dxo-label>
          <dxi-validation-rule message="{{'REGISTRY.DEVICE.VALIDATION.COMBINED_FIELD_FORMAT' | translate}}"
                               type="required"></dxi-validation-rule>
          <dxi-validation-rule message="{{'REGISTRY.DEVICE.VALIDATION.COMBINED_FIELD_FORMAT' | translate}}"
                               pattern="^[78][NEO][12]$" type="pattern"></dxi-validation-rule>
        </dxi-item>

      </ng-container>
      <!---------------------------->
      <!--      MODBUS_TCP        -->
      <!---------------------------->

      <ng-container *ngIf="editedDeviceFull?.protocolType == 'MODBUS_TCP'">

        <dxi-item [editorOptions]="deviceEditTextOptions" dataField="transportConfiguration.ipAddress">
          <dxo-label text="{{'REGISTRY.DEVICE.IP_ADDRESS' | translate}}"></dxo-label>
          <dxi-validation-rule message="{{'REGISTRY.DEVICE.VALIDATION.IP_ADDRESS' | translate}}"
                               type="required"></dxi-validation-rule>
          <dxi-validation-rule message="{{'REGISTRY.DEVICE.VALIDATION.GENERIC_FORMAT_INVALID' | translate}}"
                               pattern="^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$"
                               type="pattern"></dxi-validation-rule>
        </dxi-item>

        <dxi-item [editorOptions]="deviceEditNumberOptions" dataField="transportConfiguration.node"
                  editorType="dxNumberBox">
          <dxo-label text="{{'REGISTRY.DEVICE.NODE' | translate}}"></dxo-label>
          <dxi-validation-rule message="{{'REGISTRY.DEVICE.VALIDATION.NODE' | translate}}"
                               type="required"></dxi-validation-rule>
          <dxi-validation-rule type="range" [min]="0" [max]="255"></dxi-validation-rule>
        </dxi-item>

        <dxi-item [editorOptions]="deviceEditNumberOptions" dataField="transportConfiguration.port"
                  editorType="dxNumberBox">
          <dxo-label text="{{'REGISTRY.DEVICE.PORT' | translate}}"></dxo-label>
          <dxi-validation-rule message="{{'REGISTRY.DEVICE.VALIDATION.PORT' | translate}}"
                               type="required"></dxi-validation-rule>
        </dxi-item>

        <dxi-item [editorOptions]="deviceEditNumberOptions" dataField="transportConfiguration.timeout"
                  editorType="dxNumberBox">
          <dxo-label text="{{'REGISTRY.DEVICE.TIMEOUT' | translate}}"></dxo-label>
          <dxi-validation-rule message="{{'REGISTRY.DEVICE.VALIDATION.TIMEOUT' | translate}}"
                               type="required"></dxi-validation-rule>
        </dxi-item>
      </ng-container>

      <!---------------------------->
      <!--      SIEMENS_S7        -->
      <!---------------------------->

      <ng-container *ngIf="editedDeviceFull?.protocolType == 'SIEMENS_S7'">

        <dxi-item [editorOptions]="deviceEditTextOptions" dataField="transportConfiguration.ipAddress">
          <dxo-label text="{{'REGISTRY.DEVICE.IP_ADDRESS' | translate}}"></dxo-label>
          <dxi-validation-rule message="{{'REGISTRY.DEVICE.VALIDATION.IP_ADDRESS' | translate}}"
                               type="required"></dxi-validation-rule>
          <dxi-validation-rule message="{{'REGISTRY.DEVICE.VALIDATION.GENERIC_FORMAT_INVALID' | translate}}"
                               pattern="^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$"
                               type="pattern"></dxi-validation-rule>
        </dxi-item>

        <dxi-item [editorOptions]="deviceEditNumberOptions" dataField="transportConfiguration.rack"
                  editorType="dxNumberBox">
          <dxo-label text="{{'REGISTRY.DEVICE.RACK' | translate}}"></dxo-label>
          <dxi-validation-rule message="{{'REGISTRY.DEVICE.VALIDATION.RACK' | translate}}"
                               type="required"></dxi-validation-rule>
          <dxi-validation-rule type="range" [min]="0"></dxi-validation-rule>
        </dxi-item>

        <dxi-item [editorOptions]="deviceEditNumberOptions" dataField="transportConfiguration.slot"
                  editorType="dxNumberBox">
          <dxo-label text="{{'REGISTRY.DEVICE.SLOT' | translate}}"></dxo-label>
          <dxi-validation-rule message="{{'REGISTRY.DEVICE.VALIDATION.SLOT' | translate}}"
                               type="required"></dxi-validation-rule>
          <dxi-validation-rule type="range" [min]="0"></dxi-validation-rule>
        </dxi-item>

        <dxi-item [editorOptions]="deviceEditNumberOptions" dataField="transportConfiguration.port"
                  editorType="dxNumberBox">
          <dxo-label text="{{'REGISTRY.DEVICE.PORT' | translate}}"></dxo-label>
          <dxi-validation-rule message="{{'REGISTRY.DEVICE.VALIDATION.PORT' | translate}}"
                               type="required"></dxi-validation-rule>
          <dxi-validation-rule type="range" [min]="0" [max]="65535"></dxi-validation-rule>
        </dxi-item>

        <dxi-item [editorOptions]="deviceEditNumberOptions" dataField="transportConfiguration.timeout"
                  editorType="dxNumberBox">
          <dxo-label text="{{'REGISTRY.DEVICE.TIMEOUT' | translate}}"></dxo-label>
          <dxi-validation-rule message="{{'REGISTRY.DEVICE.VALIDATION.TIMEOUT' | translate}}"
                               type="required"></dxi-validation-rule>
        </dxi-item>
      </ng-container>

    </dxi-tab>
    <dxi-tab
      [tabTemplate]="'titleWithValidation'"
      title="{{'REGISTRY.DEVICE.TABS.METRICS' | translate}}">
      <dxi-item dataField="devices" style="gap: 10px; display: flex; flex-direction: row;">
        <div *dxTemplate>
          <div
            style="display: flex; position: absolute; flex-direction: column; top: 0; bottom: 0; left: 0; right: 0;gap: 10px;padding: 20px;">
            <div style="overflow: hidden;flex: 2 1 0">
              <app-measure-group-table
                #groupMetricDataGrid
                *ngIf="editedDeviceFull"
                [groups]="editedDeviceFull.metricGroupInstances"
                [protocolType]="editedDeviceFull.protocolType"
                [selectedGroup]="selectedMetricGroup"
                [editable]="isEditMode"
                [showToggleAllCheckbox]="false"
                [showAddButton]="true"
                [showDeleteRowButton]="true"
                [functionColumnReadOnly]="false"
                emptyMessageKey="REGISTRY.DEVICE.TEMPLATE_IMPORT.EMPTY.NO_DEVICE_GROUPS"
                [metricRowStateTracker]="metricRowStateTracker"
                (metricEditBlocked)="focusActiveMetricEdit()"
                (groupClick)="selectedMetricGroup = $event"
                (groupsChanged)="onGroupsChanged()">
              </app-measure-group-table>
            </div>

            <div style="overflow: hidden;flex: 3 1 0">
              <app-measure-metric-table
                #metricDataGrid
                *ngIf="selectedMetricGroup"
                [metrics]="selectedMetricGroup.metrics"
                [rowStateTracker]="metricRowStateTracker"
                [rowStateScope]="getRowKey(selectedMetricGroup)"
                [protocolType]="editedDeviceFull.protocolType"
                [groupTransportConfiguration]="selectedMetricGroup.transportConfiguration"
                [editable]="isEditMode"
                [showWm2eColumns]="selectedMetricGroup.isWritableOnEdge"
                [showCsvImportExport]="true"
                [showToolbarActions]="true"
                [showDeleteRowButton]="true"
                [dataTypeColumnReadOnly]="false"
                [showRawTransportColumns]="true"
                emptyMessageKey="REGISTRY.DEVICE.TEMPLATE_IMPORT.EMPTY.NO_METRICS"
                (metricsChanged)="checkEditDeviceValidation();">
              </app-measure-metric-table>
            </div>
          </div>
        </div>

      </dxi-item>
    </dxi-tab>
  </dxi-item>

</dx-form>
